import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/mobile/panther_960x1064.webp")